module.exports = __webpack_public_path__ + "img/brain.a2bd4b97.svg";